import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Cryptocurrencies from "./pages/Cryptocurrencies";
import Bookmarked from "./pages/Bookmarked";
import Layout from "./components/Layout";
import CryptocurrenciesDetail from "./pages/CryptocurrenciesDetail";
import Home from "./components/Home";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="Cryptocurrencies" element={<Cryptocurrencies />} />
          <Route
            path="CryptocurrenciesDetail/:id"
            element={<CryptocurrenciesDetail />}
          />
          <Route path="Bookmarked" element={<Bookmarked />} />
        </Route>
      </Routes>
      <Analytics />
    </BrowserRouter>
  );
}

export default App;
